module.exports = __webpack_public_path__ + "img/02_full.5104a18a.jpg";